import { actionType } from "../actions/mottakertyperActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const mottakertyperReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default mottakertyperReducer;
